import React from 'react';

interface Props {
  children: number | undefined;
}

const BIGGEST_ONE_DEC_NUMBER = 9;

export const LooksClothesHanger: React.FC<Props> = ({ children }) => {
  if (!children) return null;

  return (
    <svg width="63" height="36" viewBox="0 0 63 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="63" height="36" rx="18" fill="black" fillOpacity="0.5" />

      <path
        d="M22.9991 17.5088C22.7214 17.5088 22.5362 17.3236 22.4899 17.0458C22.4436 16.0274 22.5362 15.3793 22.814 15.1016C22.9991 14.9164 23.138 14.7775 23.3232 14.6386C23.6935 14.3146 23.8324 14.222 23.8324 13.8054C23.8324 13.3425 23.4621 12.9721 22.9991 12.9721C22.5362 12.9721 22.1659 13.3425 22.1659 13.8054C22.1659 14.0831 21.9344 14.3146 21.6567 14.3146C21.3789 14.3146 21.1475 14.0831 21.1475 13.8054C21.1475 12.787 21.9807 12 22.9529 12C23.9713 12 24.7582 12.8333 24.7582 13.8054C24.7582 14.6849 24.2953 15.0553 23.8787 15.4256C23.7398 15.5182 23.6472 15.6571 23.5084 15.7497C23.4621 15.9348 23.4158 16.4903 23.4621 16.9532C23.5084 17.2773 23.3232 17.5088 22.9991 17.5088Z"
        fill="white"
      />

      <path
        d="M31.1928 23.0177H14.8054C13.787 23.0177 13 22.1844 13 21.2123C13 20.2401 13.5555 19.592 14.7128 19.268L22.9065 16.5831C22.9991 16.5368 23.138 16.5368 23.2305 16.5831L31.3316 19.2217C32.4427 19.5457 32.9982 20.1938 32.9982 21.166C33.0445 22.1844 32.2112 23.0177 31.1928 23.0177ZM23.0454 17.5552L14.9906 20.1938C14.0647 20.4716 14.0184 20.8419 14.0184 21.2123C14.0184 21.6752 14.3888 22.0455 14.8517 22.0455H31.2391C31.702 22.0455 32.0723 21.6752 32.0723 21.2123C32.0723 20.8419 31.9797 20.4716 31.1002 20.1938L23.0454 17.5552Z"
        fill="white"
      />

      <text x={children > BIGGEST_ONE_DEC_NUMBER ? '38' : '42'} y="24" fill="white">
        {children}
      </text>
    </svg>
  );
};
